/**
 * Impls dos use cases de configuração do catálogo pedagógico.
 *
 * @since H.1 (pedagógico novo)
 */
import type {
  EducationLevel, UpsertEducationLevelCommand,
  KnowledgeArea, UpsertKnowledgeAreaCommand,
  Titulacao, UpsertTitulacaoCommand,
  RegraRematricula, UpsertRegraRematriculaCommand,
} from '@/domain/model/CatalogConfig';
import type {
  EducationLevelGateway, KnowledgeAreaGateway, TitulacaoGateway, RegraRematriculaGateway,
} from '@/application/port/out/CatalogConfigGateways';
import type {
  ListEducationLevelsUseCase, CreateEducationLevelUseCase, UpdateEducationLevelUseCase,
  ListKnowledgeAreasUseCase, CreateKnowledgeAreaUseCase, UpdateKnowledgeAreaUseCase,
  ListTitulacoesUseCase, CreateTitulacaoUseCase, UpdateTitulacaoUseCase,
  ListRegrasRematriculaUseCase, CreateRegraRematriculaUseCase, UpdateRegraRematriculaUseCase,
} from '@/application/port/in/CatalogConfigUseCase';

export class ListEducationLevels implements ListEducationLevelsUseCase {
  constructor(private readonly g: EducationLevelGateway) {}
  execute(): Promise<EducationLevel[]> { return this.g.list(); }
}
export class CreateEducationLevel implements CreateEducationLevelUseCase {
  constructor(private readonly g: EducationLevelGateway) {}
  execute(cmd: UpsertEducationLevelCommand): Promise<EducationLevel> { return this.g.create(cmd); }
}
export class UpdateEducationLevel implements UpdateEducationLevelUseCase {
  constructor(private readonly g: EducationLevelGateway) {}
  execute(id: string, cmd: UpsertEducationLevelCommand): Promise<EducationLevel> { return this.g.update(id, cmd); }
}

export class ListKnowledgeAreas implements ListKnowledgeAreasUseCase {
  constructor(private readonly g: KnowledgeAreaGateway) {}
  execute(): Promise<KnowledgeArea[]> { return this.g.list(); }
}
export class CreateKnowledgeArea implements CreateKnowledgeAreaUseCase {
  constructor(private readonly g: KnowledgeAreaGateway) {}
  execute(cmd: UpsertKnowledgeAreaCommand): Promise<KnowledgeArea> { return this.g.create(cmd); }
}
export class UpdateKnowledgeArea implements UpdateKnowledgeAreaUseCase {
  constructor(private readonly g: KnowledgeAreaGateway) {}
  execute(id: string, cmd: UpsertKnowledgeAreaCommand): Promise<KnowledgeArea> { return this.g.update(id, cmd); }
}

export class ListTitulacoes implements ListTitulacoesUseCase {
  constructor(private readonly g: TitulacaoGateway) {}
  execute(): Promise<Titulacao[]> { return this.g.list(); }
}
export class CreateTitulacao implements CreateTitulacaoUseCase {
  constructor(private readonly g: TitulacaoGateway) {}
  execute(cmd: UpsertTitulacaoCommand): Promise<Titulacao> { return this.g.create(cmd); }
}
export class UpdateTitulacao implements UpdateTitulacaoUseCase {
  constructor(private readonly g: TitulacaoGateway) {}
  execute(id: string, cmd: UpsertTitulacaoCommand): Promise<Titulacao> { return this.g.update(id, cmd); }
}

export class ListRegrasRematricula implements ListRegrasRematriculaUseCase {
  constructor(private readonly g: RegraRematriculaGateway) {}
  execute(): Promise<RegraRematricula[]> { return this.g.list(); }
}
export class CreateRegraRematricula implements CreateRegraRematriculaUseCase {
  constructor(private readonly g: RegraRematriculaGateway) {}
  execute(cmd: UpsertRegraRematriculaCommand): Promise<RegraRematricula> { return this.g.create(cmd); }
}
export class UpdateRegraRematricula implements UpdateRegraRematriculaUseCase {
  constructor(private readonly g: RegraRematriculaGateway) {}
  execute(id: string, cmd: UpsertRegraRematriculaCommand): Promise<RegraRematricula> { return this.g.update(id, cmd); }
}
